const _uppermanagementnav = [
  {
    _tag: "CSidebarNavDropdown",
    name: "Contracts",
    route: "/contracts",
    icon: "cil-file",
    _children: [
      {
        _tag: "CSidebarNavItem",
        to: "/contracts/profitandlossreporting",
        name: "Profit and Loss Reporting",
      }
    ]
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Reporting",
    route: "/reporting",
    icon: "cil-bar-chart",
    _children: [
      {
        _tag: "CSidebarNavItem",
        to: "/reporting/power-bi",
        name: "Power BI",
      },
    ]
  },
  {
    _tag: "CSidebarNavItem",
    name: "Settings",
    to: "/settings",
    icon: "cil-settings",
  },
]

export default _uppermanagementnav;